import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, Link } from 'react-router-dom';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';
import Loader from '../components/loader';

function App() {

    const location = useLocation();
    const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
	const userType = sessionStorage.getItem("TRCUserType");
    const [loader, setLoader] = useState(false);

    const [orderData, setOrderData] = useState(null);
    const [orderId, setOrderId] = useState(null);
    const [cartItems, setCartItems] = useState([]);
    const [edit, setEdit] = useState(false);

    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };

    useEffect(() => {
        const orderid = getQueryParam('id');
        setOrderId(orderid);
    }, [userID]);

	

    const getOrder = async () => {
        setLoader(true);
        setCartItems([]);
		try {
			const response = await axios.post('https://api.trucoo.in/orders/order-details/', {orderId: orderId}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			if(response.data.status === 'success'){
				setOrderData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
        setLoader(false);
	};


	useEffect(() => {
		getOrder();
	},[orderId]);

    const addCart = () => {

        if (orderData && orderData?.orderData) {
            const updatedCartItems = orderData.orderData.map((items) => ({
                product: items.item,
                qty: items.qty,
                price: items.price,
                name: items.itemName,
                hsn: items.itemHsn,
                weight: items.weight,
                unit: items.unit,
                gst: items.gst,
                type: items.type,
                code: items.itemCode,
                crates: items.crates,
            }));
    
            setCartItems(updatedCartItems);
        }
    };
    

    useEffect(()=> {
        addCart();
    },[orderData]);

    const editQty = (qty, item) => {
        setCartItems((prevItems) =>
            prevItems.map((cartItem) =>
                cartItem.product === item
                    ? { ...cartItem, qty: qty }
                    : cartItem          
            )
        );
    };

    const removeItem = (item) => {
        setCartItems((prevItems) =>
            prevItems.filter(
                (cartItem) => cartItem.product !== item
            )
        );
    };


    const placeOrder = async () => {
		const sendData = {
			dealerId: orderData && orderData?.dealerData?.id,
			total: orderData && orderData?.totalPayment,
			gst: orderData && orderData?.gst,
			items: cartItems,
            user: userID,
            orderId: orderId,
		}

		try {
			const response = await axios.post('https://api.trucoo.in/dealers/add-items/', sendData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			//console.log(response.data);

			if(response.data.status === 'success'){
                setOrderData(null);
				changeStatus();
			}
		  } catch (error) {
			console.error(error);
		  }
	};

    const changeStatus = async () => {
        try {
			const response = await axios.post('https://api.trucoo.in/orders/status/', {orderId: orderId, userId: userID}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){
				getOrder();
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
    };

    const calculateTotals = () => {
    let totalCrates = 0;
    let totalLiters = 0;
    let totalAmount = 0;
    let totalQty = 0;

    if (orderData?.orderData) {
        orderData.orderData.forEach(item => {
            const qty = Number(item.qty);
            const weight = Number(item.weight);
            const crate = Number(item.crates);
            const amount = Number(item.subtotal);

            totalCrates += qty;
            totalQty += qty * crate;
            totalLiters += (qty * crate * weight) / 1000;
            totalAmount += amount;
        });
    }
    return {
        totalCrates: totalCrates.toFixed(2),
        totalLiters: totalLiters.toFixed(2),
        totalAmount: totalAmount.toFixed(2),
        totalQty: totalQty.toFixed(2)
    };
};

const { totalCrates, totalLiters, totalAmount, totalQty } = calculateTotals();

// console.log(orderData?.employeeData?.employeeType);

let cratesValue = 0;
let qty = 0;
let weight = 0;
let total = 0;
let gstValue = 0;

console.log(cartItems);

return(
<>
    {loader && <Loader /> }
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">

			<div class="box">
                <div class="box-header with-border">
				  <h4 class="box-title">Order Details</h4>
				  <p class="mb-0 box-subtitle">{orderId}</p>
                  {!edit ?
                    <button className="btn btn-light" onClick={()=> window.history.back()} style={{width: '200px', float: 'right', marginTop: '-40px'}} ><i class="fa fa-arrow-left"></i> Back to Orders</button>
                  :
                    <button className='btn btn-light' onClick={()=> setEdit(prev=> !prev)} style={{width: '200px', float: 'right', marginTop: '-40px'}}><i class="fa fa-arrow-left"></i> Cancel Edit</button>
                  }
                  </div>
                <div class="box-body">
                    <div class="row">
                        {edit ?
                        <div class="col-lg-12 fs-12" align="center">
                            <h3>{orderData?.dealerData?.dealer}</h3>
                            <hr />
                            <table className="table-sm table-bordered fs-12" width="100%">
						        <thead>
							        <tr class="text-dark">
								        <th width="3%">S.No</th>
								        <th>Item</th>
								        <th width="15%">Crates</th>
								        <th width="10%">Packets</th>
								        <th width="10%">L/KG</th>
								        <th width="5%">Remove</th>
							        </tr>
                                </thead>
                                <tbody>
                                    {cartItems?.map((item, index) =>
                                        <tr>
                                            <td className='text-center'>{index+1}</td>
                                            <td>{item?.name}</td>
                                            <td><input type="number" step=".01" className='form-control text-center' value={item?.qty} onChange={(e)=> editQty(e.target.value, item?.product)} /></td>
                                            <td className='text-end'>{Number( parseFloat(item?.qty) * parseFloat(item?.crates)).toFixed(2)}</td>
                                            <td className='text-end'>{Number( (parseFloat(item?.qty) * parseFloat(item?.crates) * parseFloat(item?.weight))/1000).toFixed(2)}</td>
                                            <td className='text-center'><button className='btn btn-sm btn-danger' onClick={()=> removeItem(item?.product)}><i className='fa fa-trash'></i></button></td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>
                            <div className='d-flex mt-4' style={{alignItems: 'end', justifyContent:'end', gap: '10px'}}>
                                <button className='btn btn-sm btn-warning'>Add Item</button>
                                <button className='btn btn-sm btn-success'>Save Order</button>
                            </div>
                        </div>
                        :
                        <>
                        <div class="col-lg-12 mt-4 fs-12">
                            <div style={{border: '1px solid #333', borderRadius: '10px', padding: '15px', minHeight: '200px'}}>
                            <div class="row">
                                
                                <div class="col-lg-6 mt-2">
                                    
                                        <h6>Invoice To</h6>
                                        <small> <b>{orderData?.dealerData?.dealer}</b><br />
                                            {orderData?.dealerData?.name}<br /> {orderData?.dealerData?.address}<br />
                                            {orderData?.dealerData?.gst}, {orderData?.dealerData?.phone}, {orderData?.dealerData?.email}
                                        </small> 

                                        <h6 class="mt-4">Ships To</h6>
                                        <small> <b>{orderData?.shipping?.company}</b><br />
                                            {orderData?.shipping?.address}<br />
                                            {orderData?.shipping?.phone}, {orderData?.shipping?.email}
                                        </small> 

                                        <h6 class="mt-4">Dispatch From</h6>
                                        <small> <b>{orderData?.dispatchAddress?.company}</b><br />
                                            {orderData?.dispatchAddress?.address}<br />
                                            {orderData?.dispatchAddress?.phone}, {orderData?.dispatch?.email}
                                        </small> 
                                    </div>
                                
                               
                            
                                <div class="col-lg-3 mt-2">
                                        <h6>Employee</h6>
                                        <p> {orderData?.employeeData?.employeeName}- <small>{orderData?.employeeData?.employeeId}</small> <br />
                                            {orderData?.employeeData?.employeePhone}<br />
                                            {orderData?.employeeData?.companyEmail}<br /><br />
                                            Placed on : {orderData?.orderDate}<br />
                                            Order Value : ₹ {Number(orderData?.totalPayment).toFixed(2)}<br />
                                            Vehicle Number : {orderData?.vNum}<br />
                                            E Way Bill Number : {orderData?.evNum}<br />
                                            Zone : {orderData?.dealerData?.zoneData?.zone}<br />
                                            Route : {orderData?.dealerData?.routes}<br />
                                            Place : {orderData?.dealerData?.locations}<br />
                                           
                                        </p> 
                                </div>
                               
                                <div class="col-lg-3 mt-2">
                                        <h6>Remarks</h6>
                                        <p> {orderData?.remarks}</p> 
                                </div>
                                </div>
                            </div>
                        </div>


                        <div class="col-lg-9 mt-2">
                            <div class="box-header with-border">
				                <p class="mb-0 box-subtitle">Order Items</p>
				            </div>
				            <div class="box-body">
					            <div class="table-responsive">
					                <table className="table-sm table-bordered fs-12" width="100%">
						                <thead>
							                <tr class="text-dark">
								                <th width="5%">S.No</th>
								                <th>Item</th>
								                <th>Input</th>
								                <th class="text-end">Cartes</th>
								                <th class="text-end">Qty</th>
								                <th class="text-end">Weight</th>
								                <th class="text-end">Price</th>
								                <th class="text-end">GST</th>
								                <th class="text-end">Amount</th>
							                </tr>
                                        </thead>
						                <tbody>
							                {orderData ? orderData?.orderData.map((item, index) => {
                                                const price = parseFloat(item.price);
                                                const gst = parseFloat(item.gst);
                                                const productGst = parseFloat(price - ( price / (1+ gst/100) ));
                                                const productPrice = parseFloat(price - productGst);
                                                const rate = parseFloat(productPrice.toFixed(2) * parseFloat(item.qty) * parseFloat(item.crates)).toFixed(2);
                                                const gstRate = rate * (parseFloat(item.gst)/100);
                                                const gstRate2 = parseFloat(gstRate / 2).toFixed(2);

                                                cratesValue += parseFloat(item.qty);
                                                qty += parseFloat(parseFloat(item.qty) * parseFloat(item.crates));
                                                weight += (parseFloat(item.qty) * parseFloat(item.crates) *  parseFloat(item.weight) / 1000);
                                                total += (parseFloat( parseFloat(rate) + parseFloat(gstRate2) + parseFloat(gstRate2)));
                                                gstValue += (parseFloat(parseFloat(gstRate2) + parseFloat(gstRate2)));
                                                return (
                                                    <tr key={index}>
                                                        <td>{index+1}</td>
                                                        <td class="text-dark">{item.itemName}</td>
                                                        <td class="text-dark">{item.inputs}</td>
                                                        <td class="text-end">{parseFloat(item.qty).toFixed(2)}</td>
                                                        <td class="text-end">{(parseFloat(item.qty) * parseFloat(item.crates)).toFixed(2)}</td>
                                                        <td class="text-end">{(parseFloat(item.qty) * parseFloat(item.crates) *  parseFloat(item.weight) / 1000).toFixed(2)}</td>
                                                        <td class="text-end">₹ {parseFloat(productPrice).toFixed(2)}</td>
                                                        <td class="text-end">₹ {parseFloat(parseFloat(gstRate2) + parseFloat(gstRate2)).toFixed(2)}</td>
                                                        <td class="text-end">₹ {parseFloat( parseFloat(rate) + parseFloat(gstRate2) + parseFloat(gstRate2)).toFixed(2)}</td>
                                                    </tr>
							                    )}
                                             ):(
								                <tr>
									                <td colSpan={6}>No Order Details Data</td>
								                </tr>
							                )}
							
						                </tbody>	
                                        <tfoot>
                                            <tr class="text-dark fw-bold">
                                                <td colSpan="3" class="text-start">Total</td>
                                                <td class="text-end">{parseFloat(cratesValue).toFixed(2)}</td>
                                                <td class="text-end">{parseFloat(qty).toFixed(2)}</td>
                                                <td class="text-end">{parseFloat(weight).toFixed(2)}</td>
                                                <td></td>
                                                <td class="text-end">{parseFloat(gstValue).toFixed(2)}</td>
                                                <td class="text-end">₹ {parseFloat(total).toFixed(2)}</td>
                                            </tr>
                                        </tfoot>

					                </table>
					            </div>              
				            </div>  

                        </div>

                        <div class="col-lg-3 mt-2">
                            {/* <table width="100%" class="mt-4">
                                <tr>
                                    <td style={{padding: '5px'}}>Sub Total</td>
                                    <td style={{padding: '5px'}}>₹ {(Number(orderData?.totalPayment) - Number(orderData?.gst)).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td style={{padding: '5px'}}>GST</td>
                                    <td style={{padding: '5px'}}>₹ {Number(orderData?.gst).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <th style={{padding: '5px'}}>Grand Total</th>
                                    <th style={{padding: '5px'}}>₹ {Number(orderData?.totalPayment).toFixed(2)}</th>
                                </tr>
                                
                            </table> */}
                         

                             <div class="box-header with-border">
				                <p class="mb-0 box-subtitle">Approvals</p>
				            </div>
				            <div class="box-body">
                           
                            {(userType === 'gm' || userType === 'admin1' || userType === 'admin2' || (orderData?.employeeData?.employeeType === 'account' && userType === 'account')) ?
                                orderData?.status === 'Placed' ?
                                <div class="col-lg-12 mt-4" align="center">
                                    <p class="text-warning">Pending for Approval</p>
                                    <button class="btn btn-primary" onClick={()=>changeStatus()}>Approve & Add to Route</button>
                                </div>
                                :
                                <div class="col-lg-12 mt-4" align="center">
                                    <p class="text-success">Approved & Added to Route</p>
                                </div>
                            :
                                orderData?.status === 'Placed' ?
                                <div class="col-lg-12 mt-4" align="center">
                                    <p class="text-warning">Waiting for Approval</p>
                                    <a href={`/edit-order?id=${orderId}`} class="btn btn-info" >Edit</a>
                                </div>
                                :
                                <div class="col-lg-12 mt-4" align="center">
                                    <p class="text-success">Order Approved</p>
                                </div>
                            }       
                            <div class="col-lg-12 mt-4" align="center">              
                                <button className='btn btn-warning' onClick={()=> setEdit(prev=> !prev)}>Edit Order</button>
                            </div>       
                        </div>        
                    </div>   
                    </> 
                    }
                </div>
                </div>				
			  </div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;